export function rounder(base: number): number {
  return base == 0 || base
    ? Math.round(base * 100) / 100
    : 0;
}
